import '@bd-uikit-web/styles/_base.scss';

import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import bdErrorTracking from '@bd-uikit-web/js-helpers/bdErrorTracking';

import Layout from './pages/Layout';

import './styles/main.scss';

// TODO: Extract this and other endpoints out into a proper config file.
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
  bdReq.setApiUrl('http://localhost:3004');
} else {
  bdReq.setApiUrl('https://api.blackdove.io');
}

bdErrorTracking.install('bd-accounts-portal');

render(
  <div>
    <Router>
      <Route path="/" render={(props) => <Layout {...props} />} public />
    </Router>
  </div>,
  document.getElementById('app')
);
